import { render } from "./FeatureGate.vue?vue&type=template&id=69b35130&scoped=true"
import script from "./FeatureGate.vue?vue&type=script&lang=js"
export * from "./FeatureGate.vue?vue&type=script&lang=js"

import "./FeatureGate.vue?vue&type=style&index=0&id=69b35130&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b35130"]])

export default __exports__